import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { ClarityIcons, twoWayArrowsIcon } from '@cds/core/icon';
import { DatePipe } from '@angular/common';
import { ProjectFormComponent } from "../project-form/project-form.component";
import { ClrIconModule } from "@clr/angular";
import { ComponentFormComponent } from "../../component/component-form/component-form.component";
import { ProjectSteps } from "../../../_shared/interfaces";

import { environment as env } from "../../../../environments/environment";

@Component({
  selector: 'app-project-add',
  standalone: true,
  templateUrl: './project-add.component.html',
  styleUrls: ['./project-add.component.sass'],
  imports: [
      RouterLink,
      ProjectFormComponent,
      ClrIconModule,
      ComponentFormComponent
  ],
  providers: [DatePipe]
})
export class ProjectAddComponent implements OnInit {
  companyId: number = 0;
  employeeLeader: number = 0;
  employeePhm: number = 0;
  devMode: boolean;

  constructor(
    private route: ActivatedRoute,
  ) {
    ClarityIcons.addIcons(twoWayArrowsIcon);
    this.devMode = env.stages.dev;
  }

  ngOnInit() {
    const params = this.route.snapshot.paramMap;
    this.companyId = parseInt(params.get('cid') ?? '0', 10);
    this.employeePhm = parseInt(params.get('pid') ?? '0', 10);
    // Log zur Fehlerbehebung
    if (this.devMode) console.log("Company ID:", this.companyId);
    if (this.devMode) console.log("Employee Leader ID:", this.employeeLeader);
    if (this.devMode) console.log("Employee PHM ID:", this.employeePhm);
  }

  onProjectAdded(project: ProjectSteps) {
    // Nach erfolgreicher Erstellung zur Übersicht navigieren
    // this.router.navigate(['/component/overview/true']);
  }
}
